import { render, staticRenderFns } from "./goods-label.vue?vue&type=template&id=9638b308&scoped=true"
import script from "./goods-label.vue?vue&type=script&lang=js"
export * from "./goods-label.vue?vue&type=script&lang=js"
import style0 from "./goods-label.vue?vue&type=style&index=0&id=9638b308&prod&lang=css"
import style1 from "./goods-label.vue?vue&type=style&index=1&id=9638b308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9638b308",
  null
  
)

export default component.exports